import { render } from "./DataTableHeader.vue?vue&type=template&id=24889cca"
import script from "./DataTableHeader.vue?vue&type=script&lang=js"
export * from "./DataTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__